// extracted by mini-css-extract-plugin
export default {"button":"button_button__VWeAX","button25":"button_button25__fh7Q5","button49":"button_button49__VRZCy","button100":"button_button100__16J3h","button144":"button_button144__5UpuH"};